<ui-input-select
  label="Description type"
  [labelColor]="labelColor"
  [valueOptions]="defaultValues"
  (onChangeEvent)="onChange($event)"
  [value]="value"
  [required]="required"
  [default_value]="default_value"
></ui-input-select>
